import { render } from "./LoadingIcon.vue?vue&type=template&id=3c8a304b"
import script from "./LoadingIcon.vue?vue&type=script&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script